/* Progressive disclosure only: native details and anchors work without JavaScript. */
if (!customElements.get('tb-editorial-faq')) {
  customElements.define('tb-editorial-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const button = this.querySelector('[data-expand-all]');
      const items = [...this.querySelectorAll('details')];
      if (!button || !items.length) return;
      const sync = () => { button.textContent = items.every(item => item.open) ? 'Tout fermer' : 'Tout ouvrir'; };
      button.hidden = false;
      button.addEventListener('click', () => { const open = !items.every(item => item.open); items.forEach(item => { item.open = open; }); sync(); }, {signal:this.controller.signal});
      items.forEach(item => item.addEventListener('toggle', sync, {signal:this.controller.signal}));
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
